<div
  class="object-link-field {{stylingClass}}"
  [ngClass]="{'toneDownTextColor': toneDownTextColor}"
>
  @for (item of items; track $index) {
    <div
      class="object-link-field__item"
      [ngClass]="{'hide-value': !showAllItems && $index >= visibleItemsCount, 'has-show-more': !showAllItems && items.length > visibleItemsCount}"
      [class.has-show-more]="!showAllItems && items.length > visibleItemsCount"
    >
      @if (showAllItems || $index < visibleItemsCount) {
        <app-object-url
          class="object-link-field__objectUrl"
          [ngClass]="{'text-link': !disableLinks}"
          [object]="item"
          [listName]="'overview'"
          [disable]="disableLinks"
          [aClass]="stylingClass"
        >
          <span class="object-url-content">
            @if (useMaterialSymbols) {
              <mat-icon class="material-symbols-outlined">
                {{ iconToMaterialSymbol(item.$$icon) }}
              </mat-icon>
            }
            @else {
              <i
                class="object-icon object-link-field__object-url-icon {{item.$$icon}}"
              ></i>
            }

            <span
              class="object-link-field__object-url-name"
              [innerHTML]="item.artifact_name"
              [matTooltip]="item.artifact_name"
            ></span>
          </span>
        </app-object-url>
      }
    </div>
  }

  @if (!showAllItems && items.length > visibleItemsCount) {
    <div class="show-more-wrapper">
      <button
        mat-button
        type="button"
        class="object-link-field__show-more overview-field__show-more"
        [ngClass]="{'active': showMore}"
        [matTooltip]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
        matTooltipPosition="above"
        [attr.aria-label]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
        (pointerdown)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
        (touchstart)="$event.stopPropagation()"
        (click)="$event.preventDefault(); $event.stopPropagation()"
        (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
        (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
        [matMenuTriggerFor]="toggleMoreFieldLink"
        (menuOpened)="showMore = true;"
        (menuClosed)="showMore = false;"
      >
        {{ items.length - visibleItemsCount }}
        <mat-icon iconPositionEnd>
          expand_more
        </mat-icon>
      </button>
    </div>
    <mat-menu
      #toggleMoreFieldLink="matMenu"
      (click)="$event.stopPropagation()"
      (keydown)="null"
      class="removePaddingInMatMenu overview-show-more-menu-panel"
    >
      <mat-list class="overview-show-more-menu">
        @for (item of items; track $index) {
          <ng-container>
            @if ($index >= visibleItemsCount) {
              <mat-list-item [ngClass]="{'text-link': !disableLinks}">
                <app-object-url
                  [object]="item"
                  [listName]="'overview'"
                  [disable]="disableLinks"
                >
                  <span class="object-url-content">
                    @if (useMaterialSymbols) {
                      <mat-icon class="material-symbols-outlined">
                        {{ iconToMaterialSymbol(item.$$icon) }}
                      </mat-icon>
                    }
                    @else {
                      <i
                        class="object-icon object-link-field__object-url-icon {{item.$$icon}}"
                      ></i>
                    }

                    <span>
                      {{item.artifact_name}}
                    </span>
                  </span>
                </app-object-url>
              </mat-list-item>
            }
          </ng-container>
        }
      </mat-list>
    </mat-menu>
  }
</div>
